export function LoadingStep() {
  return (
    <div className="flex flex-col items-center justify-center py-12">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-rose-500" />
      <p className="mt-4 text-slate-500">Loading...</p>
    </div>
  );
}

export default LoadingStep;
